<template>
  <div v-if="isPartnersFetching">
    <LaunchpadLoader class="tw:w-full tw:flex tw:justify-center tw:items-center tw:flex-1" />
  </div>
  <div>
    <RateConnectOnboardingContainer />
  </div>
</template>
<script setup lang="ts">
import RateConnectOnboardingContainer from '@/components/rateConnect/onboarding/RateConnectOnboardingContainer.vue'
import LaunchpadLoader from '@/components/dashboard/common/LaunchpadLoader.vue'

import { usePartners } from '@/components/rateConnect/queries'
import { selectedAccommodationId } from '@/layouts/queries'

const { isFetching: isPartnersFetching } = usePartners(selectedAccommodationId)
</script>
